import { SubmissionsProvider } from "@/components/DirectorySubmissions/Form/SubmissionsProvider";
import Spinner from "@/components/Spinner";
import { useAuth } from "@/contexts/AuthHook";
import type React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedLayout: React.FC = () => {
  const { session, accountType, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Spinner />;
  }

  if (!session || !user) {
    return <Navigate to="/auth/sign-in" replace state={{ from: location }} />;
  }

  if (accountType === "attorney") {
    return (
      <Navigate
        to="/attorney/directory-submissions/review-submissions/"
        replace
      />
    );
  }

  // Don't wrap V2 routes with the legacy SubmissionsProvider
  const isV2Route = location.pathname.includes("/directory-submissions-v2");

  return isV2Route ? (
    <Outlet />
  ) : (
    <SubmissionsProvider>
      <Outlet />
    </SubmissionsProvider>
  );
};

export default ProtectedLayout;
